import { useEffect, useState } from "react";
import { Tabs } from "@mantine/core";
import "@mantine/core/styles.css";
import { motion } from "framer-motion";

import { TbReload } from "react-icons/tb";
import { ourTechnologies, ourTechnologyBtns } from "../../utils/constants";
import { TechnologyData } from "../../utils/interfaces";

const OurTechnologies = () => {
  const [selectedTab, setSelectedTab] = useState("frontend");

  const [techOption, setTechOption] = useState<
    { _id: string; value: string }[]
  >([]);

  const [techData, setTechData] = useState<TechnologyData[]>([]);
  const [filteredTech, setFilteredTech] = useState<TechnologyData[]>([]);

  // const getTechnology = async () => {
  //   const response = await getTechnologyData();
  //   const response2 = await getTechnologyOption();
  //   setTechData(response);
  //   setTechOption(response2);

  //   const defData = Array.isArray(response)
  //     ? response.filter((data: any) => data.category === "frontend")
  //     : [];
  //   setFilteredTech(defData);
  // };

  // useEffect(() => {
  //   getTechnology();
  // }, []);

  const handleMouseEvent = (value: string) => {
    setSelectedTab(value);
    const filterData = techData.filter((data) => data.category === value);
    setFilteredTech(filterData);
  };

  // static data for now

  useEffect(() => {
    setTechData(ourTechnologies);
    setTechOption(ourTechnologyBtns);
    const filterData = ourTechnologies.filter(
      (data: any) => data.category === "frontend"
    );
    setFilteredTech(filterData);
  }, []);

  function handleReload() {
    // getTechnology()
  }
  const capitalizeFirstLetter = (str: string) => {
    if (str === "cms") return "CMS";
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  return (
    <div className="relative px-p83 bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950 bg-cover py-8 500:py-12 min-h-[90vh] flex flex-col justify-center overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500/8 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <p className="text-2xl 500:text-3xl pt-6 500:pt-8 font-merry-bold tracking-tight">
          Our <span className="text-primary-500">Technologies</span>
        </p>
        <p className="text-base 500:text-lg 700:text-xl font-light py-1.5 poppins-regular tracking-tight text-neutral-300 italic">
          Revolutionizing your business with innovative technologies
        </p>
        <p className="text-sm 500:text-base poppins-regular tracking-tight text-neutral-300 max-w-3xl">
          Designing and developing innovative and professional software solutions
          for hundreds of companies across global tech markets for almost a
          decade now.
        </p>
      </motion.div>
      <Tabs
        variant="pills"
        color="#0078D1"
        radius="xl"
        defaultValue={selectedTab}
        value={selectedTab}
      >
        <Tabs.List>
          <div className="pt-8 500:pt-12 pb-10 800:pb-16 gap-x-3 500:gap-x-4 1000:gap-x-6 1100:gap-x-8 1200:gap-x-10 1300:gap-x-12 1400:gap-x-14 gap-y-3 flex-wrap flex">
            {techOption.length > 0 ? (
              techOption.map(({ _id, value }) => (
                <Tabs.Tab
                  onMouseEnter={() => handleMouseEvent(value)}
                  key={_id}
                  value={value}
                  className="!px-6 500:!px-8 !py-3 !text-base 500:!text-lg font-poppins-semibold tracking-tight !rounded-xl !bg-gradient-to-br !from-neutral-800/80 !to-neutral-900/80 !backdrop-blur-sm !border-2 !border-neutral-700/50 !text-neutral-300 hover:!border-primary-500/50 hover:!bg-gradient-to-br hover:!from-primary-500/20 hover:!to-primary-600/10 hover:!text-primary-400 !transition-all !duration-300 !shadow-lg hover:!shadow-xl data-[active=true]:!bg-gradient-to-br data-[active=true]:!from-primary-500 data-[active=true]:!to-primary-600 data-[active=true]:!border-primary-500 data-[active=true]:!text-white data-[active=true]:!shadow-xl"
                >
                  {capitalizeFirstLetter(value)}
                </Tabs.Tab>
              ))
            ) : (
              <button
                className="text-3xl absolute right-[50%] text-primary-400"
                onClick={() => handleReload()}
              >
                <TbReload />
              </button>
            )}
          </div>
        </Tabs.List>

        <Tabs.Panel value={selectedTab}>
          <div className="grid grid-cols-2 750:grid-cols-3 1000:grid-cols-4 1200:grid-cols-5 gap-3 500:gap-4 1400:gap-6 pb-8 800:pb-16">
            {filteredTech.length > 0 &&
              filteredTech.map(({ icon, title, _id }, index) => (
                <motion.div
                  key={_id}
                  className="group border-2 border-neutral-700/50 hover:border-primary-500/50 bg-gradient-to-br from-neutral-800/90 via-neutral-800 to-neutral-900/90 hover:from-primary-500/20 hover:via-primary-500/10 hover:to-transparent cursor-pointer mx-auto w-28 h-28 375:w-40 375:h-40 500:w-52 500:h-48 text-center flex justify-center items-center rounded-2xl shadow-lg hover:shadow-xl hover:shadow-primary-500/20 transition-all duration-300 backdrop-blur-sm"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                  whileHover={{ y: -8, scale: 1.05 }}
                >
                  <div>
                    <motion.img
                      src={icon}
                      alt={title}
                      className="m-auto tech__img__responsive w-20 500:w-24 filter brightness-0 invert group-hover:brightness-100 group-hover:invert-0 transition-all duration-300"
                      whileHover={{ scale: 1.1 }}
                      transition={{ duration: 0.3 }}
                    />
                    <p className="font-poppins-medium tracking-tight text-sm 375:text-base 500:text-lg pt-2 375:pt-4 text-neutral-300 group-hover:text-primary-400 transition-colors duration-300">
                      {title}
                    </p>
                  </div>
                </motion.div>
              ))}
          </div>
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};

export default OurTechnologies;
